// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3N7bR","field":"styles_field__3NIqh","fieldCol":"styles_fieldCol__9DWqi","diffCol":"styles_diffCol__1XJIq","diff":"styles_diff__2B1SF"};